import { render, staticRenderFns } from "./CurrencyTypes.vue?vue&type=template&id=1c2e0031"
import script from "./CurrencyTypes.vue?vue&type=script&lang=js"
export * from "./CurrencyTypes.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTypes.vue?vue&type=style&index=0&id=1c2e0031&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports